import { formatIsoDateToLocale } from './date.service'

/**
 * Helpers para o filtro de Data de Agendamento.
 *
 * O agendamento de uma entrega é feito na tela 3.16 com data e hora. O filtro usa o
 * campo `proxima_data_agendamento` (próximo agendamento futuro ou, na falta dele, o
 * último), que já chega da API formatado como dd/MM/yyyy HH:mm e é o mesmo valor
 * exibido na coluna "Dt. Próx. Agendamento" da 3.4. `agendamento_entrega` é usado
 * apenas como fallback, para payloads que não trazem o campo formatado.
 */

export function formatAgendamentoEntrega(entrega) {
  if (!entrega) return null
  if (entrega.proxima_data_agendamento) return entrega.proxima_data_agendamento
  if (!entrega.agendamento_entrega) return null

  const data = formatIsoDateToLocale(entrega.agendamento_entrega)
  return data.isValid ? data.toFormat('dd/MM/yyyy HH:mm') : null
}

/**
 * Converte dd/MM/yyyy HH:mm em timestamp, apenas para ordenar as opções.
 */
function parseAgendamentoParaOrdenacao(agendamento) {
  const [data, hora = '00:00'] = agendamento.split(' ')
  const [dia, mes, ano] = data.split('/')
  const [horas, minutos] = hora.split(':')
  return new Date(ano, mes - 1, dia, horas, minutos).getTime()
}

/**
 * Monta as opções do multi select a partir das entregas, sem repetir data/hora e
 * mantendo a ordem cronológica.
 */
export function buildAgendamentosOptions(entregas) {
  const agendamentos = new Set()

  ;(entregas || []).forEach(entrega => {
    const agendamento = formatAgendamentoEntrega(entrega)
    if (agendamento) agendamentos.add(agendamento)
  })

  return [...agendamentos]
    .sort((um, outro) => parseAgendamentoParaOrdenacao(um) - parseAgendamentoParaOrdenacao(outro))
    .map(agendamento => ({ label: agendamento, value: agendamento }))
}

/**
 * Uma entrega passa no filtro quando nenhuma data foi selecionada ou quando a sua
 * data/hora de agendamento é uma das selecionadas.
 */
export function matchAgendamentoSelecionado(entrega, selectedAgendamentos) {
  if (!selectedAgendamentos || !selectedAgendamentos.length) return true
  return selectedAgendamentos.includes(formatAgendamentoEntrega(entrega))
}
